export const questions = [
  {
    dimension: "Exigências do Trabalho",
    text: "Com que frequência você precisa fazer suas tarefas com muita pressa? (ex.: trabalhar correndo para dar conta do dia)",
    options: ["Nunca/Quase nunca", "Raramente", "Às vezes", "Frequentemente", "Sempre"]
  },
  {
    dimension: "Exigências do Trabalho",
    text: "Seu trabalho exige muito esforço de você? (ex.: você termina o dia bem cansado, física ou mentalmente)",
    options: ["Nunca/Quase nunca", "Raramente", "Às vezes", "Frequentemente", "Sempre"]
  },
  {
    dimension: "Exigências do Trabalho",
    text: "Você tem tempo suficiente para terminar suas tarefas? (dentro do seu horário normal, sem precisar correr)",
    options: ["Sempre", "Frequentemente", "Às vezes", "Raramente", "Nunca/Quase nunca"]
  },
  {
    dimension: "Exigências do Trabalho",
    text: "Você é interrompido muitas vezes durante o trabalho? (ex.: precisa parar o que está fazendo para resolver outras coisas)",
    options: ["Nunca/Quase nunca", "Raramente", "Às vezes", "Frequentemente", "Sempre"]
  },
  {
    dimension: "Exigências do Trabalho",
    text: "Seu trabalho mexe muito com suas emoções? (ex.: lidar com situações tristes, tensas ou estressantes)",
    options: ["Nunca/Quase nunca", "Raramente", "Às vezes", "Frequentemente", "Sempre"]
  },
  {
    dimension: "Relações Sociais e Liderança",
    text: "Seu chefe direto se preocupa se você está bem no trabalho? (ex.: pergunta como você está, escuta suas dificuldades)",
    options: ["Nunca/Quase nunca", "Raramente", "Às vezes", "Frequentemente", "Sempre"]
  },
  {
    dimension: "Relações Sociais e Liderança",
    text: "Seu chefe direto ajuda para que o trabalho aconteça bem? (ex.: dá orientações claras, resolve problemas, apoia a equipe)",
    options: ["Nunca/Quase nunca", "Raramente", "Às vezes", "Frequentemente", "Sempre"]
  },
  {
    dimension: "Relações Sociais e Liderança",
    text: "O clima entre você e seus colegas é bom? (ex.: vocês se dão bem e se respeitam no dia a dia)",
    options: ["Nunca/Quase nunca", "Raramente", "Às vezes", "Frequentemente", "Sempre"]
  },
  {
    dimension: "Relações Sociais e Liderança",
    text: "Existe ajuda entre os colegas de trabalho? (ex.: um colega ajuda o outro quando alguém está com dificuldade)",
    options: ["Nunca/Quase nunca", "Raramente", "Às vezes", "Frequentemente", "Sempre"]
  },
  {
    dimension: "Relações Sociais e Liderança",
    text: "Seus colegas te escutam quando você tem algum problema no trabalho? (ex.: quando você desabafa ou pede um conselho)",
    options: ["Nunca/Quase nunca", "Raramente", "Às vezes", "Frequentemente", "Sempre"]
  },
  {
    dimension: "Autonomia",
    text: "Você pode opinar sobre a quantidade de trabalho que recebe? (ex.: falar quando a demanda está alta demais)",
    options: ["Nunca/Quase nunca", "Raramente", "Às vezes", "Frequentemente", "Sempre"]
  },
  {
    dimension: "Autonomia",
    text: "Você pode decidir quando fazer uma pausa? (ex.: ir ao banheiro, beber água, respirar um pouco)",
    options: ["Nunca/Quase nunca", "Raramente", "Às vezes", "Frequentemente", "Sempre"]
  },
  {
    dimension: "Autonomia",
    text: "Você tem influência sobre com quem trabalha? (ex.: escolher a dupla ou o grupo em algumas tarefas)",
    options: ["Nunca/Quase nunca", "Raramente", "Às vezes", "Frequentemente", "Sempre"]
  },
  {
    dimension: "Autonomia",
    text: "Você consegue usar aquilo que sabe fazer no seu trabalho? (ex.: aplicar sua experiência e o que aprendeu ao longo dos anos)",
    options: ["Nunca/Quase nunca", "Raramente", "Às vezes", "Frequentemente", "Sempre"]
  },
  {
    dimension: "Sentido do Trabalho",
    text: "O trabalho que você faz tem valor para você? (ex.: você sente que faz sentido, que não é só uma obrigação)",
    options: ["Nunca/Quase nunca", "Raramente", "Às vezes", "Frequentemente", "Sempre"]
  },
  {
    dimension: "Sentido do Trabalho",
    text: "Você sente que o seu trabalho faz diferença? (ex.: ajuda outras pessoas, a equipe ou a empresa)",
    options: ["Nunca/Quase nunca", "Raramente", "Às vezes", "Frequentemente", "Sempre"]
  },
  {
    dimension: "Sentido do Trabalho",
    text: "Você está satisfeito com o que o seu trabalho pode te oferecer no futuro? (ex.: chance de crescer, estabilidade, aprender coisas novas)",
    options: ["Nunca/Quase nunca", "Raramente", "Às vezes", "Frequentemente", "Sempre"]
  },
  {
    dimension: "Insegurança e Conflitos",
    text: "Você tem medo de perder o seu emprego? (ex.: preocupação com demissão ou fim do contrato)",
    options: ["Nunca/Quase nunca", "Raramente", "Às vezes", "Frequentemente", "Sempre"]
  },
  {
    dimension: "Insegurança e Conflitos",
    text: "Você presencia ou vive brigas e discussões no trabalho? (ex.: conflitos entre colegas ou com a chefia)",
    options: ["Nunca/Quase nunca", "Raramente", "Às vezes", "Frequentemente", "Sempre"]
  },
  {
    dimension: "Insegurança e Conflitos",
    text: "Você sofre assédio moral no trabalho? (ex.: humilhações, xingamentos, ameaças ou perseguição que se repetem)",
    options: ["Nunca/Quase nunca", "Raramente", "Às vezes", "Frequentemente", "Sempre"]
  }
];
